import styled from 'styled-components';

export const DocsUploaderStyled = styled.div`
  padding-top: 16px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
